import { Dialog, DialogContent, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { DevToolsTitle, TabContainer, TabContent, Tabs, TabTitle } from './dev-tools.styles';
import { AuthTab } from './tabs/auth/auth-tab';
import { LocationTab } from './tabs/location/location-tab';

export const DevTools = () => {
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.altKey && e.key.toLowerCase() === 'a') {
        e.preventDefault();
        setSelectedTab(0);
        setOpen((prev) => !prev);
      }
    };

    document.addEventListener('keydown', handleKey);

    return () => document.removeEventListener('keydown', handleKey);
  }, []);

  const onChangeTab = (event: React.ChangeEvent<object>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { width: '680px', maxWidth: '680px' } }}>
      <DevToolsTitle>Dev Tools</DevToolsTitle>
      <DialogContent sx={{ minHeight: '500px', display: 'flex' }}>
        <TabContainer>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={selectedTab}
            onChange={onChangeTab}
            sx={{ width: '100px', flexShrink: 0 }}
          >
            <Tab label={<TabTitle>Auth</TabTitle>} />
            <Tab label={<TabTitle>Location</TabTitle>} />
            <Tab label={<TabTitle>Cache</TabTitle>} />
          </Tabs>
          <TabContent>
            {selectedTab === 0 && <AuthTab />}
            {selectedTab === 1 && <LocationTab />}
          </TabContent>
        </TabContainer>
      </DialogContent>
    </Dialog>
  );
};
